import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-[60vh] text-center">
      <div className="text-8xl font-bold text-pond/20 dark:text-pond-light/20 mb-4">
        404
      </div>
      <h1 className="text-2xl font-semibold text-slate dark:text-mist mb-2">
        Page Not Found
      </h1>
      <p className="text-chalkboard dark:text-rain-cloud mb-8 max-w-md">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <div className="flex gap-4">
        <button
          onClick={() => window.history.back()}
          className="btn-secondary"
        >
          <ArrowLeft className="w-4 h-4" />
          Go Back
        </button>
        <Link to="/" className="btn-primary">
          <Home className="w-4 h-4" />
          Dashboard
        </Link>
      </div>
    </div>
  );
}
